import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=5ebf8b76&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./TemplateList.vue?vue&type=script&lang=js&"
export * from "./TemplateList.vue?vue&type=script&lang=js&"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=5ebf8b76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf8b76",
  null
  
)

export default component.exports